function noop() {}
export { noop as default };
//# sourceMappingURL=noop.js.map
